import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";

// import DeliverySampleshuttleService from "../../../../services/deliverySampleshuttle.service"
import { getDeliverySampleshuttleByIdUser } from "../../../../actions/deliverySampleshuttle";
import { getDeliverySampleShuttleByFilter } from "../../../../actions/deliverySampleshuttle";
import { getEmployeesByCompany } from "../../../../actions/employee";
import SiteService from "../../../../services/site.service";
import employeeService from "../../../../services/employee.service";

import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/styles";
import {
  Typography,
  Container,
  Button,
  Stack,
  Grid,
  TextField,
  MenuItem,
  Paper,
  Box,
  Drawer,
  Divider,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
  ArrowBack as ArrowBackIcon,
  DownloadRounded as DownloadRoundedIcon,
  AccessTime as AccessTimeIcon,
  NoteAlt as NoteAltIcon,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import DateAdapter from "@mui/lab/AdapterDayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import UniconLoading from "../../assets/loading.gif";
import CardSampleDetail from "./NewSample/CardDetailSample";
import CardSampleRequest from "./NewSample/CardSampleRequest";
import NavButton from "../../shared/NavButton/NavButtonForm";
import ButtonBlue from "../../shared/buttonBlue";
import CreateExcel from "../../shared/createExcel";
import { height, width } from "@mui/system";
import { red } from "@mui/material/colors";

const useStyles = makeStyles((theme) => ({
  DivCoverReturn: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  Grid: {
    width: "100%",
    margin: "0 auto",
    marginTop: "20px",
    ["@media only screen and (max-width: 600px)"]: {
      width: "100%",
    },
  },
  CreateButton: {
    height: "36.5px",
    // width: "200px",
    display: "flex",
    color: "white",
    fontSize: "15px",
    borderRadius: "10px",
    // margin: "3px",
    backgroundColor: theme.palette.primary.main,
    ["&:hover"]: {
      backgroundColor: theme.palette.primary.dark,
    },
    // [theme.breakpoints.down("sm")]: {
    //   fontSize: "16px",
    //   width: "170px",
    // },
  },
  CreateButtonSearch: {
    height: "40px",
    width: "40px",
    display: "flex",
    color: "white",
    fontSize: "15px",
    borderRadius: "5px",
    margin: "3px",
    backgroundColor: theme.palette.primary.main,
    ["&:hover"]: {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  IconImage: {
    weight: "26px",
    height: "26px",
    marginRight: "3px",
  },
}));

const Root = styled("div")(({ theme }) => ({
  paddingInline: "8vw",
  [theme.breakpoints.down("sm")]: {
    paddingInline: "0",
    marginLeft: "0",
    width: "100%",
  },
}));

const DivCoverReturn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // marginTop: "10px",
  width: "100%",

  // paddingLeft: "20px",
  // paddingRight: "20px",
  // paddingInline: "8vw",
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .ButtonTypeNotClicked": {
    backgroundColor: "#B2BABB ",
    color: "white",
    fontWeight: "bold",
    ["&:hover"]: {
      borderBottom: "0px",
      backgroundColor: "#D5DBDB",
    },
  },
}));

const ButtonType = styled(Button)({
  width: "180px",
  minWidth: "180px",
  height: "50px",
  fontSize: "16px",
  borderRadius: "4px 4px 0 0",
  zIndex: "10",
  backgroundColor: "#FBFCFC",
  border: "1px solid #EEEEEE",
  borderBottom: "0",
  marginBottom: "-2px",
  fontWeight: "bold",
  "&:hover": {
    borderBottom: "0px",
    backgroundColor: "#FBFCFC",
  },
});

const NavDiv = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  overflowX: "auto",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

const NavTopButton = styled(Grid)(({ theme }) => ({
  // marginTop: "20px",
  "& .CurrentTable": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  display: "flex",
  // gap: "20px",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "center",
}));
//

const AllCards = styled("div")({
  height: "calc(100% - 153px)",
  // padding: "20px",
  marginBottom: "10px",
  paddingBottom: "0",
  paddingTop: "20px",
  // border: "1px solid #EEEEEE",
  zIndex: "1",
  // backgroundColor: "#FBFCFC",
  marginTop: "20px",
  borderRadius: "15px",
});

const SpaceOfAllCards = styled("div")({
  height: "95%",
  padding: "5px 4px 0px 4px",
  overflowY: "auto",
});

const BackButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  // position: "absolute",
  // top: "13px",
  // left: "10px",
  "&:hover": {
    backgroundColor: "inherit",
  },
  "& .Icon": {
    fontSize: "30px",
  },
}));

const Sampleshuttle = (props) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    getValues,
    setValue,
  } = useForm();
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    result,
    isFetching: isFetchingList,
    isError: errorFetchingSample,
  } = useSelector((state) => state.deliverySampleShuttleCar);
  const [deliverySampleStatus, setDeliverySampleStatus] = useState("all");
  const [listBooking, setListBooking] = useState(result[deliverySampleStatus]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: allEmployees } = useSelector((state) => state.employees);
  const [allSite, setAllSite] = useState([]);

  const [showHistory, setHistory] = useState(0);
  const [isStartDate, setStartDate] = useState(null);
  const [isEndDate, setEndDate] = useState(null);
  const [isStatus, setStatus] = useState("ทั้งหมด");
  const [isEditList, setIsEditList] = useState(false);
  const [isNewList, setIsNewList] = useState(true);

  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  const onClickCardHandler = (idBooking) => {
    window.scroll(0, 0);
    props.history.push(`/sampleshuttle/detail_booking`, {
      idBooking: idBooking,
    });
  };

  const onClickNewList = () => {
    const startDate =
      isStartDate === null
        ? null
        : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10);
    const endDate =
      isEndDate === null
        ? null
        : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10);
    setIsEditList(false);
    setIsNewList(true);
    props.history.push({
      pathname: `/sampleshuttle/NewSample/formDetailFlight`,
      state: {
        userType: "user",
        isEditList: isEditList,
        isNewList: isNewList,
      },
    });
  };

  const onClickGoBack = () => {
    props.history.push("/carbooking");
  };

  const onClickHistory = async () => {
    setHistory(1);
    // setListBooking(
    //   await dispatch(
    //     getDeliverySampleShuttleByFilter({
    //       nameSample: "",
    //       fromSite: "ทั้งหมด",
    //       toSite: "ทั้งหมด",
    //       status: "ทั้งหมด",
    //       startdate: null,
    //       enddate: null,
    //       idUser: currentUser.idUser,
    //     })
    //   )
    // );
  };
  const onClickStatus = async () => {
    setHistory(0);
    // setListBooking(
    //   await dispatch(
    //     getDeliverySampleShuttleByFilter({
    //       nameSample: "",
    //       fromSite: "ทั้งหมด",
    //       toSite: "ทั้งหมด",
    //       status: "ทั้งหมด",
    //       startdate: null,
    //       enddate: null,
    //       idUser: currentUser.idUser,
    //     })
    //   )
    // );
  };

  useEffect(() => {
    setListBooking([]);
  }, []);

  const onClickSearch = async () => {
    setListBooking([]);
    setListBookingIsSuccess([]);
    setListBookingNotSuccess([]);
    const startDate =
      isStartDate === null
        ? null
        : isStartDate.$d.toLocaleString("af-ZA").slice(0, 10);
    const endDate =
      isEndDate === null
        ? null
        : isEndDate.$d.toLocaleString("af-ZA").slice(0, 10);

    setListBooking(
      await dispatch(
        getDeliverySampleShuttleByFilter({
          nameSample: getValues("nameSample"),
          fromSite: getValues("fromSite"),
          toSite: getValues("toSite"),
          status: getValues("status"),
          startdate: startDate,
          enddate: endDate,
          idUser: currentUser.idUser,
        })
      )
    );
  };

  useEffect(async () => {
    onClickSearch();

    await SiteService.getAllSiteLocations().then((res) => {
      if (res.data) {
        setAllSite(res.data);
      }
    });
    await employeeService.getEmployeesById(currentUser.idUser).then((res) => {
      if (res.data) {
        dispatch(getEmployeesByCompany(res.data[0].idCompany));
      }
    });
  }, []);

  useEffect(async () => {
    if (!isFetchingList && listBooking) {
      // console.log(3333);
      const listA = [];
      const listB = [];
      listBooking.map((booking) => {
        if (booking.status != "ได้รับสินค้าเรียบร้อย") {
          listA.push(booking);
        } else {
          listB.push(booking);
        }
      });

      setListBookingNotSuccess(listA);
      setListBookingIsSuccess(listB);
    }
  }, [listBooking, isFetchingList]);

  // Exporting an Excel
  const excelName = "รายงานการจองรถรับส่งตัวอย่างการทดลอง";
  const excelHeaderAndWidth = [
    { header: "ลำดับ", width: 15 },
    { header: "ชื่อตัวอย่าง", width: 30 },
    { header: "เกรด", width: 15 },
    { header: "Lot Number", width: 30 },
    { header: "รายละเอียด", width: 50 },
    { header: "ชื่อผู้ส่ง", width: 30 },
    { header: "เบอร์โทรผู้ส่ง", width: 30 },
    { header: "จุดรับของต้นทาง", width: 50 },
    { header: "วันที่ส่ง", width: 20 },
    { header: "เวลารับของต้นทาง", width: 20 },
    { header: "ชื่อผู้รับ", width: 30 },
    { header: "เบอร์โทรศัพท์ผู้รับของ", width: 30 },
    { header: "จุดปลายทาง", width: 50 },
    { header: "วันที่รับของ", width: 20 },
    { header: "เวลารับของ", width: 20 },
    { header: "ชื่อคนขับรถ", width: 30 },
    { header: "สถานะ", width: 30 },
  ];
  const excelHeader = excelHeaderAndWidth.map((item) => item.header);
  const excelColumnWidth = excelHeaderAndWidth.map((item) => item.width);
  const RightDrawer = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const isDrawerFullWidthScreen = useMediaQuery((theme) =>
      theme.breakpoints.down("sm")
    );

    const toggleDrawer = (open) => (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      setIsDrawerOpen(open);
    };

    const tempAllData = [];
    const tempWaitingForPickup = [];
    const tempPickedUp = [];
    const tempDelivered = [];
    const tempCompleted = [];

    const excelCategories = [
      { title: "สถานะทั้งหมด", data: tempAllData },
      { title: "สถานะรอรับสินค้า", data: tempWaitingForPickup },
      { title: "รับสินค้าเรียบร้อย", data: tempPickedUp },
      { title: "ส่งสินค้าเรียบร้อย", data: tempDelivered },
      { title: "ได้รับสินค้าเรียบร้อย", data: tempCompleted },
    ];

    useEffect(() => {
      if (isDrawerOpen) {
        let globalOrder = 0;
        let waitingForPickupOrder = 0;
        let pickedUpOrder = 0;
        let deliveredOrder = 0;
        let completedOrder = 0;

        tempAllData.length = 0;
        tempWaitingForPickup.length = 0;
        tempPickedUp.length = 0;
        tempDelivered.length = 0;
        tempCompleted.length = 0;

        listBooking.forEach((item) => {
          const transformedItem = {
            order: ++globalOrder,
            nameSample: item.nameSample || "",
            nameGrade: item.nameGrade || "",
            lotNumber: item.lotNumber || "",
            detail: item.detail || "",
            nameSender: item.nameSender || "",
            phoneSender: item.phoneSender || "",
            fromPlace: item.fromPlaceName || "",
            date: item.date
              ? new Date(item.date).toLocaleDateString("th-TH", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "",
            startTime: item.startTime || "",
            nameRecipient: item.nameRecipient || "",
            phoneRecipient: item.phoneRecipient || "",
            toPlace: item.toPlaceName || "",
            completedDate: item.completedDate
              ? new Date(item.completedDate).toLocaleDateString("th-TH", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "",
            completedTime: item.completedDate
              ? new Date(item.completedDate).toLocaleTimeString("th-TH", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "",
            nameDriver: item.driver
              ? `${item.driver.firstname} ${item.driver.lastname}`
              : "",
            status: item.status,
          };
          tempAllData.push(transformedItem);
          if (item.status === "รอรับสินค้า") {
            tempWaitingForPickup.push({
              ...transformedItem,
              order: ++waitingForPickupOrder,
            });
          }
          if (item.status === "รับสินค้าเรียบร้อย") {
            tempPickedUp.push({
              ...transformedItem,
              order: ++pickedUpOrder,
            });
          }
          if (item.status === "ส่งสินค้าเรียบร้อย") {
            tempDelivered.push({
              ...transformedItem,
              order: ++deliveredOrder,
            });
          }
          if (item.status === "ได้รับสินค้าเรียบร้อย") {
            tempCompleted.push({
              ...transformedItem,
              order: ++completedOrder,
            });
          }
        });
      }
    }, [isDrawerOpen]);

    return (
      <div>
        <ButtonBlue
          variant="outlined"
          onClick={toggleDrawer(true)}
          startIcon={<DownloadRoundedIcon />}
          customColor={!isFetchingList && listBooking ? undefined : "secondary"}
          disabled={!isFetchingList && listBooking ? false : true}
        >
          ดาวน์โหลด
        </ButtonBlue>
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
          sx={{ zIndex: 1300 }}
        >
          <Box
            sx={{
              width: {
                xs: "100vw",
                sm: 598,
              },
            }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            <Typography sx={{ padding: "16px" }}>ดาวน์โหลด</Typography>
            {isDrawerFullWidthScreen && (
              <IconButton
                onClick={toggleDrawer(false)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
            <Divider />
            <Box
              sx={{
                padding: "8px 24px 24px 24px",
              }}
            >
              {excelCategories.map(({ title, data }, index) => (
                <Box
                  sx={{
                    paddingTop: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                  key={index}
                >
                  <Typography>{title}</Typography>
                  <CreateExcel
                    name={`${excelName}-${title}`}
                    columnWidths={excelColumnWidth}
                    headerValues={excelHeader}
                    buttonType="contained"
                    data={data}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Drawer>
      </div>
    );
  };

  return (
    <Container maxWidth="xl">
      <Root>
        <DivCoverReturn className="page">
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "flex-row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginTop: "30px",
              marginBottom: "30px",
            }}
          >
            <Grid item lg={7} md={12} sm={12} xs={12} sx={{ display: "flex" }}>
              <Grid>
                <BackButton disableRipple onClick={onClickGoBack}>
                  <ArrowBackIcon
                    className="Icon"
                    style={{ color: "#99A8B2" }}
                  />
                </BackButton>
              </Grid>
              <Typography variant="h4">รายการจองรถรับส่งตัวอย่างการทดลอง</Typography>
            </Grid>

            <NavTopButton
              item
              lg={5}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", gap: "16px" }}
            >
              {showHistory === 0 && (
                <Grid item lg={6} md={6} sm={6} xs={6} sx={{ height: "40px" }}>
                  <ButtonBlue
                    variant="contained"
                    startIcon={<AccessTimeIcon />}
                    onClick={onClickHistory}
                    style={{ height: "100%", width: "100%" }}
                  >
                    ประวัติรายการ
                  </ButtonBlue>
                </Grid>
              )}
              {showHistory === 1 && (
                <Grid item lg={6} md={6} sm={6} xs={6} sx={{ height: "40px" }}>
                  <ButtonBlue
                    variant="contained"
                    startIcon={
                      <img
                        src="/assets/Image/Icon/list.png"
                        alt="List Icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                    }
                    onClick={onClickStatus}
                    style={{ height: "100%", width: "100%" }}
                  >
                    สถานะรายการ
                  </ButtonBlue>
                </Grid>
              )}
              <Grid item lg={6} md={6} sm={6} xs={6} sx={{ height: "40px" }}>
                <Button
                  variant="contained"
                  startIcon={
                    <img
                      src="/assets/Image/Icon/form.png"
                      alt="Logo"
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  onClick={onClickNewList}
                  style={{ height: "100%", width: "100%", borderRadius: "8px" }}
                  isEditList={isEditList}
                  isNewList={isNewList}
                >
                  เพิ่มการจองรถ
                </Button>
              </Grid>
            </NavTopButton>
          </Grid>
          <Grid
            container
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              border: "1px solid #EEEEEE",
              backgroundColor: "#FBFCFC",
              // padding: "25px 30px 25px 30px",

              borderRadius: "15px",
              [theme.breakpoints.down("sm")]: {
                // padding: "25px 30px 25px 15px",
              },
              [theme.breakpoints.down("md")]: {
                // padding: "25px 30px 25px 15px",
              },
            })}
          >
            <Grid
              container
              spacing={2}
              style={{
                marginTop: "25px",
                marginLeft: "15px",
                marginRight: "35px",
              }}
            >
              <Grid item xs={12} md={6}>
                <TextField
                  id="search"
                  type="search"
                  fullWidth
                  label="ค้นหาชื่อตัวอย่างการทดลอง"
                  InputProps={{
                    style: {
                      borderRadius: "5px",
                      background: "rgb(254, 254, 254)",
                    },
                  }}
                  inputProps={{ ...register("nameSample") }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} locale="th">
                  <Controller
                    name="startdate"
                    inputProps={{ ...register("startdate") }}
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <MobileDatePicker
                        {...field}
                        label="วันที่เริ่ม"
                        inputFormat="DD MMMM YYYY"
                        value={isStartDate}
                        onChange={(date) => setStartDate(date)}
                        clearable
                        componentsProps={{
                          actionBar: {
                            actions: ["clear", "cancel", "accept"],
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputProps={{
                              style: {
                                borderRadius: "5px",
                              },
                            }}
                            fullWidth
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs} locale="th">
                  <Controller
                    name="enddate"
                    inputProps={{ ...register("enddate") }}
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <MobileDatePicker
                        {...field}
                        minDate={isStartDate}
                        value={isEndDate}
                        onChange={(date) => setEndDate(date)}
                        label="วันที่สิ้นสุด"
                        inputFormat="DD MMMM YYYY"
                        clearable
                        componentsProps={{
                          actionBar: {
                            actions: ["clear", "cancel", "accept"],
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputProps={{
                              style: {
                                borderRadius: "5px",
                              },
                            }}
                            fullWidth
                          />
                        )}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              {showHistory === 0 && (
                <Grid item xs={12} md={2.5}>
                  <TextField
                    inputProps={{ ...register("status") }}
                    value={isStatus}
                    onChange={(e) => setStatus(e.target.value)}
                    label="สถานะ"
                    select
                    InputProps={{
                      style: {
                        borderRadius: "5px",
                      },
                    }}
                    fullWidth
                    defaultValue={"ทั้งหมด"}
                  >
                    <MenuItem value={"ทั้งหมด"}>ทั้งหมด</MenuItem>
                    <MenuItem value={"รอรับสินค้า"}>รอรับสินค้า</MenuItem>
                    <MenuItem value={"รับสินค้าเรียบร้อย"}>
                      รับสินค้าเรียบร้อย
                    </MenuItem>
                    <MenuItem value={"ส่งสินค้าเรียบร้อย"}>
                      ส่งสินค้าเรียบร้อย
                    </MenuItem>
                    {/* <MenuItem value={"ได้รับสินค้าเรียบร้อย"}>
                      ได้รับสินค้าเรียบร้อย
                    </MenuItem> */}
                  </TextField>
                </Grid>
              )}
              {showHistory === 1 && (
                <Grid item xs={12} md={2.5}>
                  <TextField
                    inputProps={{ ...register("status") }}
                    value={isStatus}
                    onChange={(e) => setStatus(e.target.value)}
                    label="สถานะ"
                    select
                    InputProps={{
                      style: {
                        borderRadius: "5px",
                      },
                    }}
                    fullWidth
                    defaultValue={"ทั้งหมด"}
                  >
                    <MenuItem value={"ทั้งหมด"}>ทั้งหมด</MenuItem>
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12} md={4.75}>
                <TextField
                  inputProps={{ ...register("fromSite") }}
                  label="จุดรับ"
                  defaultValue={"ทั้งหมด"}
                  select
                  InputProps={{
                    style: {
                      borderRadius: "5px",
                    },
                  }}
                  fullWidth
                >
                  <MenuItem value="ทั้งหมด">ทั้งหมด</MenuItem>
                  {allSite.map((value, index) => (
                    <MenuItem key={index} value={value.idScgSite}>
                      {value.noSite !== null &&
                        `Site${value.noSite}: ${value.nameSite}`}
                      {value.noSite === null && `${value.nameSite}`}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={4.75}>
                <TextField
                  inputProps={{ ...register("toSite") }}
                  label="จุดส่ง"
                  defaultValue={"ทั้งหมด"}
                  select
                  InputProps={{
                    style: {
                      borderRadius: "5px",
                    },
                  }}
                  fullWidth
                >
                  <MenuItem value="ทั้งหมด">ทั้งหมด</MenuItem>
                  {allSite.map((value, index) => (
                    <MenuItem key={index} value={value.idScgSite}>
                      {value.noSite !== null &&
                        `Site${value.noSite} :${value.nameSite}`}
                      {value.noSite === null && `${value.nameSite}`}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={2}
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  <ButtonBlue
                    variant="contained"
                    onClick={onClickSearch}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "35px",
                    }}
                    startIcon={<SearchIcon />}
                  >
                    ค้นหา
                  </ButtonBlue>
                  <RightDrawer />
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <AllCards>
            <SpaceOfAllCards>
              {isFetchingList ? (
                <Paper
                  sx={{
                    overflow: "hidden",
                    border: "1px solid #EEEEEE",
                    backgroundColor: "#FFFFFF",
                    marginBottom: "20px",
                    padding: "25px 30px 25px 30px",
                    borderRadius: "15px",
                    textAlign: "center", // จัดให้รูปอยู่กึ่งกลาง
                  }}
                >
                  <img
                    src={UniconLoading}
                    alt="Loading..."
                    style={{ width: "300px" }}
                  />
                  {/* ปรับขนาดของภาพตามที่ต้องการ */}
                </Paper>
              ) : (
                <>
                  {" "}
                  {errorFetchingSample ? (
                    <Paper
                      sx={{
                        // width: "100%",
                        overflow: "hidden",
                        border: "1px solid #EEEEEE",
                        backgroundColor: "#FFFFFF",

                        marginBottom: "20px",
                        // padding: "0px 25px 25px 0px",
                        padding: "25px 30px 25px 30px",

                        borderRadius: "15px",
                      }}
                    >
                      <Typography
                        style={{ textAlign: "center", fontSize: "24px" }}
                      >
                        ไม่มีรายการ
                      </Typography>
                    </Paper>
                  ) : (
                    <>
                      {showHistory === 0 &&
                        (listBooking &&
                        listBookingNotSuccess &&
                        listBookingNotSuccess.length > 0 ? (
                          <CardSampleRequest
                            onClickCardHandler={onClickCardHandler}
                            listBooking={listBookingNotSuccess}
                            allSite={allSite}
                          />
                        ) : (
                          <Paper
                            sx={{
                              overflow: "hidden",
                              border: "1px solid #EEEEEE",
                              backgroundColor: "#FFFFFF",
                              marginBottom: "20px",
                              padding: "25px 30px",
                              borderRadius: "15px",
                            }}
                          >
                            <Typography
                              style={{ textAlign: "center", fontSize: "24px" }}
                            >
                              ไม่มีรายการ
                            </Typography>
                          </Paper>
                        ))}

                      {showHistory === 1 &&
                        (listBooking &&
                        listBookingIsSuccess &&
                        listBookingIsSuccess.length > 0 ? (
                          <CardSampleRequest
                            onClickCardHandler={onClickCardHandler}
                            listBooking={listBookingIsSuccess}
                            allSite={allSite}
                          />
                        ) : (
                          <Paper
                            sx={{
                              overflow: "hidden",
                              border: "1px solid #EEEEEE",
                              backgroundColor: "#FFFFFF",
                              marginBottom: "20px",
                              padding: "25px 30px",
                              borderRadius: "15px",
                            }}
                          >
                            <Typography
                              style={{ textAlign: "center", fontSize: "24px" }}
                            >
                              ไม่มีรายการ
                            </Typography>
                          </Paper>
                        ))}
                    </>
                  )}
                </>
              )}
            </SpaceOfAllCards>
          </AllCards>
        </DivCoverReturn>
      </Root>
    </Container>
  );
};

export default Sampleshuttle;
